// ** Reducers Imports
import { combineReducers } from "redux";
import navbar from "./navbar";
import layout from "./layout";
import auth from "./authentication";
import todo from "@src/views/apps/todo/store";
import chat from "@src/views/apps/chat/store";
import users from "@src/views/apps/user/store";
import email from "@src/views/apps/email/store";
import invoice from "@src/views/apps/invoice/store";
import calendar from "@src/views/apps/calendar/store";
import ecommerce from "@src/views/apps/ecommerce/store";
import dataTables from "@src/views/tables/data-tables/store";
import permissions from "@src/views/apps/roles-permissions/store";

// @Vyrill-Reducers
import session from "../Entry/session_reducer";
import selectedBrandReducer from "../vyrill-ui-config/layout/sidebar/SwitchBrand/switch_brand_reducer";
import errors from "../Shared/Errors/errorsReducer";
import serverMessages from "../Shared/ServerMessages/ServerMessagesReducer";
import {
  videos,
  singleVideoProducts,
  videoData,
  videoParams,
  videoProductsAll,
  vipInfluencerVideoNote,
  vipInfluencerVideoURL,
  vipInfluencerDropboxVideo,
  videoAuthor,
  transcript,
  toggleTranscript,
  downloadTranscript,
  keywordsOnly,
  videoPageStates,
  VideoDetailBreadcrumb,
  videoUploadDetail,
  PublishedPageStates,
  copyTranscriptReducer,
  videoAnalysisStatus,
} from "../Pages/Video/VideoReducers";

import {
  products,
  productData,
  productParams,
  autoCompleteProductOrHashtagList,
  autoCompleteProductOrHashtagCategories,
  createProduct,
  updateProduct,
  productPageStates,
} from "../Pages/Product/ProductsReducers";
import {
  videoNotes,
  productNotes,
  influencerNotes,
} from "../Shared/Notes/NotesReducers";
import reports from "../Pages/Reports/ReportsReducer";
import copiedText from "../Shared/CopyText/CopyRedux";
import videoList from "../Shared/modules/videoList";
import videoDetail from "../Shared/modules/videoDetail";
import videoProducts from "../Shared/modules/videoProducts";
import videoAssociations from "../Shared/modules/videoAssociations";
import vip from "../Pages/Home/vip_reducer";
import home from "../Pages/Home/home_reducer";
import {
  home_competitor_brands,
  switchGraphStatus,
  switchActiveTab,
  home_Graph_Data,
} from "../Pages/Home/home_reducer";
import { navbarStatsReducer } from "../vyrill-ui-config/layout/sidebar/navbarStatsReducer";
import {
  influencers,
  influencerData,
  influencerParams,
  influencerUser,
  InfluencerPageStates,
} from "../Pages/Influencer/influencers_reducers";
import { globalParamStates } from "../Shared/GlobalParams/GlobalParamsReducers";
import {
  channels,
  messages,
  recipients,
  recipientsFetchedForUser,
  messagesFetchedForChannel,
  newChatRecipient,
  unreadMessageCounts,
  lastMessages,
} from "../Pages/Chat/ChatRedux";
import { lastSeenChannels } from "../Pages/Chat/ChannelsRedux";
import {
  licenseRequestVideo,
  licenseAgreements,
  videoLicenseAgreements,
  licenseHistory,
  purchaseHistory,
  loadingLicenseHistory,
  loadingPurchaseHistory,
} from "../Shared/Licensing/licensing_redux";
import register from "../Entry/register_reducer";
import campaignData from "../Pages/Campaign/CampaignReducers";
import { tutorials_states } from "../Shared/Tutorials/TutorialReducers";
import DashboardReducer from "../Pages/Dashborad/DashboardReducer";
import askVyrill from "../Pages/AskVyrill/AskVyrillReducer";
import modalsState from "../Shared/PopUpModals/ModalsReducer";
import { campaign_states } from "../Pages/CreateCampaign/CamapaignReducers";
import { widget_states } from "../Pages/Widget/WidgetReducer";
import sentimentReportReducer from "../Pages/Reports/NewSentimentReport/SentimentReportReducer";

const appReducer = combineReducers({
  auth,
  todo,
  chat,
  email,
  users,
  navbar,
  layout,
  invoice,
  calendar,
  ecommerce,
  dataTables,
  permissions,

  // @Vyrill
  register,
  sentimentReportReducer,
  selectedBrandReducer,
  session,
  products,
  productData,
  productParams,
  autoCompleteProductOrHashtagList,
  autoCompleteProductOrHashtagCategories,
  createProduct,
  updateProduct,
  productNotes,
  videoNotes,
  influencerNotes,
  errors,
  serverMessages,
  reports,
  copiedText,
  videos,
  singleVideoProducts,
  videoData,
  videoParams,
  videoProductsAll,
  vipInfluencerVideoNote,
  vipInfluencerVideoURL,
  vipInfluencerDropboxVideo,
  videoAuthor,
  transcript,
  toggleTranscript,
  downloadTranscript,
  keywordsOnly,
  videoList,
  videoDetail,
  videoProducts,
  videoAssociations,
  home,
  vip,
  influencers,
  influencerData,
  influencerParams,
  influencerUser,
  home_competitor_brands,
  home_Graph_Data,
  switchGraphStatus,
  switchActiveTab,
  navbarStatsReducer,
  globalParamStates,
  channels,
  messages,
  recipients,
  recipientsFetchedForUser,
  messagesFetchedForChannel,
  newChatRecipient,
  unreadMessageCounts,
  lastMessages,
  lastSeenChannels,
  licenseRequestVideo,
  licenseAgreements,
  videoLicenseAgreements,
  licenseHistory,
  purchaseHistory,
  loadingLicenseHistory,
  loadingPurchaseHistory,
  campaignData,
  videoPageStates,
  VideoDetailBreadcrumb,
  videoUploadDetail,
  productPageStates,
  InfluencerPageStates,
  PublishedPageStates,
  copyTranscriptReducer,
  tutorials_states,
  campaign_states,
  widget_states,
  DashboardReducer,
  videoAnalysisStatus,
  askVyrill,
  modalsState,
});

const rootReducer = (state, action) => {
  if (action.type === "LOGOUT") {
    return appReducer(undefined, action);
  }

  return appReducer(state, action);
};

export default rootReducer;
